import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import colors from '../../theme/colors';

const styles = {
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundImage: 'url(/background.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
  },
  overlay: {
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(10,10,26,0.7)',
  },
  card: {
    position: 'relative',
    background: 'rgba(18,18,42,0.92)',
    border: `1px solid ${colors.cardBorder}`,
    borderRadius: 12,
    padding: 40,
    width: 360,
    maxWidth: '90vw',
    backdropFilter: 'blur(12px)',
  },
  logo: {
    display: 'block',
    margin: '0 auto 24px',
    height: 48,
  },
  title: {
    color: colors.accent,
    fontSize: 22,
    fontWeight: 700,
    marginBottom: 4,
    textAlign: 'center',
  },
  subtitle: {
    color: colors.textMuted,
    fontSize: 13,
    textAlign: 'center',
    marginBottom: 32,
  },
  label: {
    display: 'block',
    color: colors.textMuted,
    fontSize: 12,
    textTransform: 'uppercase',
    marginBottom: 6,
    letterSpacing: '0.5px',
  },
  input: {
    width: '100%',
    padding: '10px 14px',
    background: colors.surface,
    border: `1px solid ${colors.cardBorder}`,
    borderRadius: 6,
    color: colors.text,
    fontSize: 14,
    marginBottom: 20,
    outline: 'none',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%',
    padding: '12px',
    background: colors.accent,
    color: colors.bg,
    border: 'none',
    borderRadius: 6,
    fontSize: 14,
    fontWeight: 700,
    cursor: 'pointer',
    letterSpacing: '0.5px',
  },
  error: {
    color: colors.danger,
    fontSize: 13,
    textAlign: 'center',
    marginBottom: 16,
  },
};

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(username, password);
      navigate('/', { replace: true });
    } catch {
      setError('Invalid username or password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.overlay} />
      <form style={styles.card} onSubmit={handleSubmit}>
        <img src="/logo-full.png" alt="Smartville" style={styles.logo} />
        <div style={styles.title}>SV360</div>
        <div style={styles.subtitle}>BESS Monitoring Dashboard</div>
        {error && <div style={styles.error}>{error}</div>}
        <label style={styles.label}>Username</label>
        <input
          style={styles.input}
          type="text"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
        />
        <label style={styles.label}>Password</label>
        <input
          style={styles.input}
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button style={styles.button} type="submit" disabled={loading}>
          {loading ? 'Signing in...' : 'Sign In'}
        </button>
      </form>
    </div>
  );
}
